module.exports = __webpack_public_path__ + "static/media/e_logo.68696971.svg";